"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverFooter;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PopoverContext = require("../context/PopoverContext");

var _Styles = require("../utils/Styles");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: inherit;\n  border-radius: inherit;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: ", ";\n  text-align: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var handlePadding = function handlePadding(hasStructuredFooter, popoverUse) {
  if (popoverUse === 'longform') return "0 " + _sizes.TOOLTIP_LONGFORM_PADDING + " " + _sizes.POPOVER_PADDING_Y;

  if (popoverUse === 'shepherd') {
    var paddingTop = hasStructuredFooter ? (0, _Styles.toPx)(parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.SHEPHERD_PADDING_Y, 10)) : '0px';
    var paddingBottom = hasStructuredFooter ? _sizes.POPOVER_PADDING_Y : _sizes.SHEPHERD_PADDING_Y;
    return paddingTop + " " + _sizes.POPOVER_PADDING_X + " " + paddingBottom + " " + _sizes.POPOVER_PADDING_X;
  }

  return _sizes.POPOVER_PADDING_Y + " " + _sizes.POPOVER_PADDING_X;
};

var Footer = _styledComponents.default.footer.withConfig({
  displayName: "UIPopoverFooter__Footer",
  componentId: "sc-1as526d-0"
})(_templateObject(), function (_ref) {
  var flush = _ref.flush,
      hasStructuredFooter = _ref.hasStructuredFooter,
      popoverUse = _ref.popoverUse;
  return flush ? '0' : handlePadding(hasStructuredFooter, popoverUse);
}, function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var hasStep = _ref3.hasStep;
  return hasStep ? (0, _styledComponents.css)(_templateObject2()) : null;
});

function UIPopoverFooter(_ref4) {
  var className = _ref4.className,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["className"]);
  return _react.default.createElement(Footer, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(className, 'uiPopoverFooter private-popover__footer'),
    popoverUse: (0, _react.useContext)(_PopoverContext.PopoverContext).use
  }));
}

UIPopoverFooter.propTypes = {
  align: _propTypes.default.oneOf(['left', 'right']).isRequired,
  children: _propTypes.default.node,
  flush: _propTypes.default.bool,
  hasStep: _propTypes.default.bool,
  hasStructuredFooter: _propTypes.default.bool
};
UIPopoverFooter.defaultProps = {
  align: 'left',
  hasStructuredFooter: false,
  hasStep: false
};
UIPopoverFooter.displayName = 'UIPopoverFooter';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/tooltip/UIPopoverFooter.js
// module id = 391
// module chunks = 5 6 7